/** Backdrop con blur: no se cierra al clicar fuera; el fondo queda desenfocado. */
export const lockedDialogSlotProps = {
  backdrop: {
    sx: {
      backgroundColor: "rgba(15, 23, 42, 0.4)",
      backdropFilter: "blur(8px)",
      WebkitBackdropFilter: "blur(8px)",
    },
  },
};

export function guardLockedDialogClose(onClose) {
  return (_event, reason) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") return;
    onClose?.();
  };
}
